import React from "react";

export default function PrivacyPolicy() {
    const style = {
        maxWidth: '100%',
        margin: 'auto',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        minHeight: '100%',
      };
    
      const headingStyle = {
        color: '#333',
        // textAlign: 'center',
      };
    
      const sectionStyle = {
        marginBottom: '20px',
        marginTop: "10px"
      };
    
  return (

    <div style={style}>
    <h2 style={headingStyle}>Privacy Policy for Dr Shine - Complete Care Dentistry</h2>

    <p
    style={{
        marginTop: "10px"
    }}
    >
      Thank you for visiting the Dr Shine. We are committed to protecting your privacy and ensuring the security of your personal information. This privacy policy outlines how we collect, use, and safeguard your data when you use our website and mobile application.
    </p>

    <div style={sectionStyle}>
      <h3>1. Information We Collect:</h3>

      <p>a. Personally Identifiable Information (PII):</p>
      <p>- Name</p>
      <p>- Contact information (email address, phone number)</p>
      <p>- Appointment details</p>
      <p>b. Non-Personal Information:</p>
      <p>We may collect non-personal information such as browser type, operating system, and IP address to enhance our website's user experience.</p>
    </div>

    <div style={sectionStyle}>
      <h3>2. How We Use Your Information:</h3>

      <p>We use your information for the following purposes:</p>
      <p>- Scheduling and managing appointments</p>
      <p>- Providing relevant dental care services</p>
      <p>- Sending appointment reminders and notifications</p>
      <p>- Improving our website and services</p>
      <p>- Responding to your inquiries and feedback</p>
    </div>


    <p>
      By using our website and mobile application, you consent to the terms outlined in this privacy policy.
    </p>

    <p>
      Thank you for choosing Dr Shine - Complete Care Dentistry. Your privacy and trust are of utmost importance to us.
    </p>
  </div>
  );
}
